import { memo } from 'react';
import { css } from '@emotion/react';
import { Handle, Position, NodeProps } from 'reactflow';
import { color, spacing, typography } from '@uniquegood/realworld-studio-design';

import type { StartNodeData } from '../types';

function StartNode({ data }: NodeProps<StartNodeData>) {
  return (
    <div css={StartNodeStyle}>
      <span css={LabelStyle}>{data.label}</span>
      <Handle type="source" position={Position.Right} css={HandleStyle} />
    </div>
  );
}

export default memo(StartNode);

const StartNodeStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 36px;
  border-radius: 999px;
  background-color: ${color.action_primary_default};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
`;

const LabelStyle = css`
  color: ${color.white};
  font-size: ${typography.size.s1};
  font-weight: ${typography.weight.bold};
  letter-spacing: 0.08em;
`;

const HandleStyle = css`
  && {
    width: 8px;
    height: 8px;
    background-color: ${color.action_primary_default};
    border: 2px solid ${color.white};
    right: -4px;
  }
`;
